// GET LOGIN
export const SIGNUP_REQUEST = "company/SIGNUP_REQUEST"
export const SIGNUP_SUCCESS = "company/SIGNUP_SUCCESS"
export const SIGNUP_FAILURE = "company/SIGNUP_FAILURE"
